import { provideStoreDevtools } from "@ngrx/store-devtools";

export const environment = {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  buildVersion: require("../../package.json").version,
  environmentName: "Development",
  production: false,
  idleSecondsBeforeWarning: 3600,
  idleSecondsBeforeLogout: 59,
  vigilantApiUrl: "https://dev.api.govigilant.app",
  keycloakAuthority: "https://identity.govigilant.app/realms/vigilant",
  keycloakClientId: "voyager2",
  keycloakRedirectUri: "/home",
  keycloakPostLogoutUri: "/home",
  keycloakResponseType: "code",
  keycloakScope: "openid profile",
  keycloakForgotPasswordURL: "https://identity.govigilant.app/realms/vigilant/login-actions/reset-credentials?client_id=voyager2",
  providers: [
    provideStoreDevtools({
      name: "(Dev) GoVigilant.App",
      maxAge: false,
      logOnly: false,
    }),
  ],
};
